var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplexionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1180_1078",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.744,
    height: 29.744,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1180_1078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8688 26.0258C12.1216 26.0258 9.78234 25.0705 7.85104 23.1599C5.91975 21.2493 4.9541 18.941 4.9541 16.2351C4.9541 14.8718 5.2123 13.6119 5.72868 12.4551C6.24507 11.2984 6.95769 10.2657 7.86653 9.35682L14.8688 2.47852L21.871 9.35682C22.7798 10.2657 23.4925 11.2984 24.0088 12.4551C24.5252 13.6119 24.7834 14.8718 24.7834 16.2351C24.7834 18.941 23.8178 21.2493 21.8865 23.1599C19.9552 25.0705 17.616 26.0258 14.8688 26.0258ZM14.8688 23.5472V5.94865L9.6016 11.1538C8.87866 11.8355 8.33645 12.6049 7.97498 13.4621C7.6135 14.3193 7.43277 15.2436 7.43277 16.2351C7.43277 18.2387 8.15571 19.9583 9.6016 21.3938C11.0475 22.8294 12.8032 23.5472 14.8688 23.5472Z",
    fill: "#EAA245"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplexionIcon);
export default __webpack_public_path__ + "static/media/ComplexionIcon.47122778ecf30102e8a7e4fc21f14514.svg";
export { ForwardRef as ReactComponent };